module.exports = __webpack_public_path__ + "static/media/logo.496ae16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 38
// module chunks = 0